import { render } from "./AutoPublishSettings.vue?vue&type=template&id=be7f79d8&scoped=true"
import script from "./AutoPublishSettings.vue?vue&type=script&lang=js"
export * from "./AutoPublishSettings.vue?vue&type=script&lang=js"

import "./AutoPublishSettings.vue?vue&type=style&index=0&id=be7f79d8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7f79d8"]])

export default __exports__